import AppRouter from "./router/AppRouter";
import { BrowserRouter as Router } from "react-router-dom";
import * as Icons from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

const iconList = Object
  .keys(Icons)
  .filter(key => key !== "fas" && key !== "prefix" )
  .map(icon => Icons[icon])

library.add(...iconList)

function App() {
  return (
    <Router>
      <AppRouter />
    </Router>
  );
}

export default App;
